import React, { useEffect, useState } from "react";
import Preloader from "../../Components/Preloader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { NavLink } from "react-router-dom";
import About_Seo from "../../SEO/About_Seo";

function AboutUs() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <div>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <About_Seo />
          <div className="page-wrapper">
            <Header />
             {/* Internal CSS */}
                    <style>
                        {`
                            .header-wrap.style1 .header-top .header-top-left .contact-item a, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a i {
                                color: #fff;
                            }
                                .header-wrap.style1 .header-top .header-top-left .contact-item a:hover, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a:hover i {
                                color: #FF414B;
                            }
                        `}
                    </style>

            {/* Content Wrapper Start */}
            <div className="content-wrapper">
              {/* Breadcrumb start */}
              <div className="breadcrumb-wrap bg-f">
                <div className="overlay bg-vulcan op-9" />
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="breadcrumb-title">
                        <h2>About Us</h2>
                        <ul className="breadcrumb-menu list-style">
                          <li>
                            <NavLink to="/">Home </NavLink>
                          </li>
                          <li>About Us</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumb end */}
              {/* About Us section Start */}
              <section className="about-wrap style1 pt-100 pb-100">
                <div className="container">
                  <div className="row gx-5 align-items-center">
                    <div className="col-lg-6">
                      <div className="wh-img bg-f about-bg-4">
                        <div className="tr-text-wrap"></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="about-content">
                        <div className="content-title style1">
                          <span>ABOUT US</span>
                          <h2>Finestpay</h2>
                          <p>
                            At Finestpay, we make sending money across borders
                            simple, secure, and stress-free. Built with a deep
                            understanding of the needs of individuals and
                            families who support loved ones abroad, our platform
                            is designed to deliver fast and reliable remittance
                            services you can trust.
                          </p>
                          <p>
                            We believe that every transfer tells a story — of
                            care, connection, and commitment. That’s why we
                            combine advanced technology with transparent pricing
                            and responsive support to ensure your money gets
                            where it needs to be, quickly and safely. Whether
                            you’re sending funds home, paying for education, or
                            supporting your community, Finestpay is here to make
                            every transaction count.
                          </p>
                          <p>
                            <strong>
                              <em>
                                Finestpay — Sending more than money. Sending
                                care.
                              </em>
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* About Us section End */}

              {/* Frequently Asked Questions section start */}
              <section className="faq-wrap ptb-100">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="content-title style1 mb-40">
                        <span>FAQ's</span>
                        <h2>Frequently Asked Questions</h2>
                      </div>
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                            >
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Why do you need my documents while registration?
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                            style={{}}
                          >
                            <div className="accordion-body">
                              <div className="single-product-text">
                                <p>
                                  We are regulated by Financial Conduct
                                  Authority in the UK. It is our legal binding
                                  to verify your identity as a UK resident.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              How can I cancel my transfer?
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse "
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p>
                                Please call us or email us at earliest possible
                                if you want to cancel your transfer. Transfer
                                paid out to the recipient cannot be cancelled.
                                If you have paid for your transfer and the
                                transfer is not processed yet, then please
                                contact us by phone and we will make necessary
                                arrangements for refunds. We may charge you a
                                small fee as handling/service charge and refund
                                you the balance amount.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingThree">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Will I get notifications about Transfer status?
                            </button>
                          </h2>
                          <div
                            id="collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p>
                                Yes. We send email notifications to keep you
                                informed. You can even view the transfer status
                                by signing in into your web account.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingfour">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefour"
                              aria-expanded="false"
                              aria-controls="collapsefour"
                            >
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              How many recipients I can add?
                            </button>
                          </h2>
                          <div
                            id="collapsefour"
                            className="accordion-collapse collapse "
                            aria-labelledby="headingfour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div className="single-product-text">
                                <p>
                                  There is no restriction on the number of
                                  recipients you may have on your account.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 text-center">
                        <NavLink to="/general-faq" className="btn style3">
                          View more FAQ's
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* Frequently Asked Questions section end */}
            </div>
            {/* Content Wrapper End */}

            {/* Footer Section Here */}
            <Footer />
          </div>
        </>
      )}
    </div>
  );
}

export default AboutUs;
